/**
 * Default home after login.
 * - EMPLOYEE + HR → /goals (HR has no org dashboard in nav; same landing as employees)
 * - ADMIN + MANAGER → /dashboard
 */
export function getPostLoginPath(user) {
  const role = (user?.role || "EMPLOYEE").toUpperCase();
  if (role === "EMPLOYEE" || role === "HR") {
    return "/goals";
  }
  return "/dashboard";
}
